/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  addTemporaryLocationMarker,
  clearTemporaryLocationMarkers,
} from './actions';
import { LatLon } from './models';

export interface TemporaryMarkersState {
  markers: LatLon[];
}

const initialState: TemporaryMarkersState = {
  markers: [],
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(addTemporaryLocationMarker, (state, action) => {
    state.markers = [...state.markers, action.payload];
  });

  builder.addCase(clearTemporaryLocationMarkers, (state) => {
    state.markers = initialState.markers;
  });
});
